import './InfoWrapperRow.sass'
import InfoWrapperRow from './InfoWrapperRow'

export default InfoWrapperRow
